window.Products.Clothing.YouthLeggings4to5years = function() {};

window.Products.Clothing.YouthLeggings4to5years.inherits(window.Products.Clothing.YouthLeggings);
window.Products.Clothing.YouthLeggings4to5years.has_3d = true;
window.Products.Clothing.YouthLeggings4to5years.id = '60-4to5years';
window.Products.Clothing.YouthLeggings4to5years.saveId = 60;
window.Products.Clothing.YouthLeggings4to5years.slug = 'youth-leggings-4to5years';
window.Products.Clothing.YouthLeggings4to5years.dpi = 150;